(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-lifextra-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var toggle = event.target.closest('[data-lifextra-menu-toggle]');

    if (!toggle) {
      return;
    }

    var expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-magnimore-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var toggle = event.target.closest('[data-magnimore-menu-toggle]');

    if (!toggle) {
      return;
    }

    var expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
  });

  } catch(e) { console.error(e); }
})();
})();
